import Headroom from 'headroom.js'; // eslint-disable-line no-unused-vars
import { debounce } from 'throttle-debounce';

function init() {
  var banner = document.querySelector('.banner');
  var $banner = $(banner);
  var headroom  = new Headroom(banner, {
    offset: 0,
    tolerance : {
        up: 0,
        down: 0,
    },
  });
  headroom.init();

  var $nav = $('#mainNav');
  var currentTop = 0;
  $nav.on('hide.bs.collapse', function () {
    $(document).scrollTop(currentTop);
    $banner.css('position', 'fixed');
    headroom.init();
  });

  $nav.on('show.bs.collapse', function () {
    currentTop = $(document).scrollTop();
    $(document).scrollTop(0);
    $banner.css('position', 'absolute');
    headroom.destroy();
  });

  $('.modal').on('show.bs.modal', function () {
    // headroom.unpin();
    headroom.freeze();
  });

  $('.modal').on('hidden.bs.modal', function () {
    setTimeout(function() {
      headroom.unfreeze();
    }, 500); // delay for the case where the link to modal extends above viewport top, and closing modal results in window scroll to top of modal link
  });

  // Fired on input change of AJAX-enabled forms or when form has specific fields
  // https://docs.gravityforms.com/gform_input_change/
  window.gform && window.gform.addAction('gform_input_change', function( elem, formId, fieldId) {
    headroom.unpin(); // needed for /contact/ to ensure nav doesn't obscure form. would be better to not call this from modal forms.
    headroom.freeze();
  }, 10, 3);

  // Fired on AJAX-enabled forms when the confirmation page is loaded.
  // https://docs.gravityforms.com/gform_confirmation_loaded/
  $(document).on('gform_confirmation_loaded', function(event, form_id) {
    headroom.unfreeze();
  });

  // case: user triggered gform_input_change then scrolls up to top
  $(window).on('scroll', debounce(100, function() {
    if($(document).scrollTop() === 0) {
      headroom.pin();
      headroom.unfreeze();
    }
  }));

  // Fired every time the form is rendered to allow custom jQuery to be executed
  // e.g. initial form load, going to the next/previous page on multi-page forms, form rendered with validation errors, confirmation message displayed, etc
  // $(document).on('gform_post_render', function(event, form_id, current_page) {
  //   headroom.freeze();
  // });
}

export default init;



// WEBPACK FOOTER //
// ./scripts/base/headroom.js